import { useSyncExternalStore } from 'react';
import { CHATWERK_WINDOW_ID } from './chat-widget.constants';

// ChatWerk reports neither opening nor closing — it mounts its window into
// <body> and removes it again, so its presence there is the state.
function subscribe(onChange: () => void): () => void {
    const observer = new MutationObserver(onChange);
    observer.observe(document.body, { childList: true });

    return () => observer.disconnect();
}

const isWindowMounted = (): boolean => document.getElementById(CHATWERK_WINDOW_ID) !== null;

/** Whether ChatWerk's chat window is currently open. */
export function useChatWindowOpen(): boolean {
    return useSyncExternalStore(subscribe, isWindowMounted, () => false);
}
